import React, { InputHTMLAttributes } from "react";
import { UseFormRegister } from "react-hook-form";

interface CheckboxInlineHookFormProps
  extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  label?: string;
  register?: UseFormRegister<any>;
  validation?: Record<string, unknown>;
  labelWidth?: string;
  readOnly?: boolean;
  checked?: boolean;
  isView?: boolean;
}

const CheckboxInlineHookForm: React.FC<CheckboxInlineHookFormProps> = ({
  name,
  label,
  register,
  validation,
  className = "",
  disabled = false,
  onClick,
  labelWidth = "w-[50px] sm:w-[70px] lg:w-[90px]",
  readOnly,
  checked,
  isView = false,
  ...props
}) => {
  const getCursorClass = () => {
    if (disabled) return "cursor-not-allowed";
    if (readOnly) return "cursor-default";
    return "cursor-pointer";
  };

  const registerProps = register ? register(name, validation) : {};

  return (
    <div className="flex items-center text-xs">
      <label
        htmlFor={name}
        className={`flex items-center justify-end ${labelWidth} mr-2 whitespace-nowrap`}
      >
        <span className="truncate expandedLabel fontExpand">{label}:</span>
      </label>

      {isView ? (
        <div
          className={`w-4 h-4 flex items-center justify-center rounded-sm border 
          ${
            checked
              ? "bg-green-500 border-green-500"
              : "bg-gray-100 border-gray-300 opacity-30"
          }`}
        >
          {checked && (
            <svg
              className="w-3 h-3 text-white"
              viewBox="0 0 12 12"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <polyline points="2,6 5,9 10,3" />
            </svg>
          )}
        </div>
      ) : (
        <input
          id={name}
          type="checkbox"
          className={`w-4 h-4 ${getCursorClass()} ${className}`}
          {...registerProps}
          disabled={disabled}
          readOnly={readOnly}
          checked={checked}
          onClick={onClick}
          {...props}
        />
      )}
    </div>
  );
};

export default CheckboxInlineHookForm;
